/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import MenuLateral from "./Componentes/MenuLateral";
import Seccion_Catalogo from "./Secciones/Seccion_Catalogo";
import {useResponsive} from "../Modulo_Responsive/Hooks/useResponsive";
import {useBotonWassFlotante} from "../Modulo_Wass_Flotante/Hooks/useBotonWassFlotante";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Mis_Compras from "./Secciones/Seccion_Mis_Compras";
import Seccion_Ofertas from "./Secciones/Seccion_Ofertas";
import Seccion_Detalle from "./Secciones/Seccion_Detalle";
import {NUMEROATENCION} from "../Constantes";

const Pagina = () => {
    const {sCell, masSM} = useResponsive()
    const {BotonWass} = useBotonWassFlotante({numero: NUMEROATENCION})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <BotonWass/>

            <Router>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 2, position: 'fixed'}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 1, mt: 9}}>
                    <MenuLateral/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{ml: masSM ? 34.6 : 0, maxWidth: '1400px'}}
                    >
                        <Routes>
                            <Route path={"*"} element={<Seccion_Catalogo/>}/>
                            <Route path={"/Home"} element={<Seccion_Catalogo/>}/>
                            <Route path={"/"} element={<Seccion_Catalogo/>}/>
                            <Route path={"/Mis_Compras"} element={<Seccion_Mis_Compras/>}/>
                            <Route path={"/Ofertas"} element={<Seccion_Ofertas/>}/>
                            <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                        </Routes>

                    </Grid>

                </Grid>


            </Router>

        </Grid>
    )

}
export default Pagina
